import { render, staticRenderFns } from "./SectionBecomeGanga7Partner.vue?vue&type=template&id=572d038f&"
import script from "./SectionBecomeGanga7Partner.vue?vue&type=script&lang=js&"
export * from "./SectionBecomeGanga7Partner.vue?vue&type=script&lang=js&"
import style0 from "./SectionBecomeGanga7Partner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports